import { useEffect, useState } from "react";
import SubscriptionCard from "../../../components/Website/SubscriptionCard";
import axios from "axios";
import { apiKey } from "../../../config/config";

function Subscriptions({ currency }) {
  const customer = JSON.parse(localStorage.getItem("rms-customer"));
  const [subscriptions, setSubscriptions] = useState([]);
  const [customerData, setCustomerData] = useState({});
  const [paymentMethods, setPaymentMethods] = useState([]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/customer/subscriptions`)
      .then((res) => {
        setSubscriptions(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });

    axios
      .get(`${apiKey}/api/rms/customer/profile`, {
        headers: {
          Authorization: `Bearer ${customer?.token}`,
        },
      })
      .then((res) => {
        setCustomerData(res.data);
      })
      .catch((err) => {
        console.error(err);
      });

    axios
      .get(`${apiKey}/api/rms/admin/payment_methods`)
      .then((res) => {
        setPaymentMethods(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [customer?.token]);
  return (
    <section className="bg-white">
      <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-md text-center mb-8 lg:mb-12">
          <h2 className="mb-4 text-[2rem] tracking-tight font-semibold text-gray-900">
            Subscribe Now and Save
          </h2>
        </div>
        <div className="flex gap-8 flex-wrap">
          {subscriptions.map((data, index) => (
            <SubscriptionCard key={index} currency={currency} data={data} customerData={customerData} paymentMethods={paymentMethods} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Subscriptions;
